<template>
  <div class="new_vip">
    <el-tabs type="border-card">
      <el-tab-pane label="待结算">
        <div class="box">
          <div class="box-title">
            <span style="font-size: 18px">积分兑换</span>
            <a
              style="font-size: 14px;margin-left: 10px"
              @click="gotoDetail('select_order', 2, 2)"
              >点击查看</a
            >
          </div>
          <div class="box-conter">
            <div class="conter">
              <div>累计消耗积分</div>
              <div>
                <strong>{{
                  (
                    Number(settle_hongbao.wait_use_point || 0) +
                    Number(settle_hongbao.settlement_use_point || 0)
                  ).toFixed(2)
                }}</strong>
                <span> 分</span>
              </div>
            </div>
            <div class="part_line"></div>
            <div class="conter">
              <div>待结算积分</div>
              <div>
                <strong>{{
                  Number(settle_hongbao.wait_use_point || 0).toFixed(2)
                }}</strong>
                <span> 分</span>
              </div>
            </div>
            <div class="conter" style="border: none">
              <div>待结算金额</div>
              <div>
                <strong>{{
                  Number(
                    settle_hongbao.wait_settlement_goods_money || 0
                  ).toFixed(2)
                }}</strong>
                <span> 元</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-title">
            <span style="font-size: 18px">用户使用红包</span>
            <a
              style="font-size: 14px;margin-left: 10px"
              @click="gotoDetail('give_bonus', 2, 2)"
              >点击查看</a
            >
          </div>
          <div class="box-conter">
            <div class="conter">
              <div>累计使用红包</div>
              <div>
                <strong>{{
                  (
                    Number(settle_hongbao.settlement_bonus_money || 0) +
                    Number(settle_hongbao.wait_settlement_bonus_money || 0)
                  ).toFixed(2)
                }}</strong>
                <span> 元</span>
              </div>
            </div>
            <div class="conter" style="border: none">
              <div>待结算红包</div>
              <div>
                <strong>{{
                  Number(
                    settle_hongbao.wait_settlement_bonus_money || 0
                  ).toFixed(2)
                }}</strong>
                <span> 元</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-title">
            <span style="font-size: 18px">油站分红</span>
            <a
              style="font-size: 14px;margin-left: 10px"
              @click="gotoDetail('give_app', 2, 2)"
              >点击查看</a
            >
          </div>
          <div class="box-conter">
            <div class="conter">
              <div>累计获得分红</div>
              <div>
                <strong>{{
                  (
                    Number(settle_hongbao.settlement_give_money || 0) +
                    Number(settle_hongbao.wait_settlement_give_money || 0)
                  ).toFixed(2)
                }}</strong>
                <span> 元</span>
              </div>
            </div>
            <div class="conter" style="border: none">
              <div>待结算分红</div>
              <div>
                <strong>{{
                  Number(
                    settle_hongbao.wait_settlement_give_money || 0
                  ).toFixed(2)
                }}</strong>
                <span> 元</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-title">
            <span style="font-size: 18px">共计待结算金额</span>
            <span
              style="font-size: 14px;color: red;display: inline-block;margin-left: 10px"
              >总金额 = 积分 - 红包 - 分红</span
            >
          </div>
          <div class="box-conter">
            <div class="conter" style="border: none">
              <div>
                <strong style="font-size: 20px">{{
                  Number(settle_hongbao.wait_settlement_money || 0).toFixed(2)
                }}</strong>
                <span> 元</span>
              </div>
              <div>
                <el-button size="medium" @click="goto_settle">去结算</el-button>
              </div>
            </div>
          </div>
        </div>
        <div style="color: red;font-size: 16px">
          提示:
          结算周期为每月15号,28号,请油站自行结算,如逾期结算,将会影响到系统的正常使用
        </div>
      </el-tab-pane>
      <el-tab-pane label="已结算">
        <div style="margin-bottom: 20px">
          <a style="font-size: 14px" @click="gotoDetail('settlement', 1, 1)"
            >查看已结算记录</a
          >
          <span style="font-size: 14px;display: inline-block;margin-left: 10px"
            >最后结算时间:{{ settle_hongbao.settlement_time }}</span
          >
        </div>
        <div class="box">
          <div class="box-title">
            <span style="font-size: 18px">积分兑换</span>
            <a
              style="font-size: 14px;margin-left: 10px"
              @click="gotoDetail('select_order', 2, 1)"
              >点击查看</a
            >
          </div>
          <div class="box-conter">
            <div class="conter">
              <div>累计消耗积分</div>
              <div>
                <strong>{{
                  (
                    Number(settle_hongbao.wait_use_point || 0) +
                    Number(settle_hongbao.settlement_use_point || 0)
                  ).toFixed(2)
                }}</strong>
                <span> 分</span>
              </div>
            </div>
            <div class="part_line"></div>
            <div class="conter">
              <div>已结算积分</div>
              <div>
                <strong>{{
                  Number(settle_hongbao.settlement_use_point || 0).toFixed(2)
                }}</strong>
                <span> 分</span>
              </div>
            </div>
            <div class="conter" style="border: none">
              <div>已结算金额</div>
              <div>
                <strong>{{
                  Number(settle_hongbao.settlement_goods_money || 0).toFixed(2)
                }}</strong>
                <span> 元</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-title">
            <span style="font-size: 18px">用户使用红包</span>
            <a
              style="font-size: 14px;margin-left: 10px"
              @click="gotoDetail('give_bonus', 2, 1)"
              >点击查看</a
            >
          </div>
          <div class="box-conter">
            <div class="conter">
              <div>累计使用红包</div>
              <div>
                <strong>{{
                  (
                    Number(settle_hongbao.settlement_bonus_money || 0) +
                    Number(settle_hongbao.wait_settlement_bonus_money || 0)
                  ).toFixed(2)
                }}</strong>
                <span> 元</span>
              </div>
            </div>
            <div class="conter" style="border: none">
              <div>已结算红包</div>
              <div>
                <strong>{{
                  Number(settle_hongbao.settlement_bonus_money || 0).toFixed(2)
                }}</strong>
                <span> 元</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-title">
            <span style="font-size: 18px">油站分红</span>
            <a
              style="font-size: 14px;margin-left: 10px"
              @click="gotoDetail('give_app', 2, 1)"
              >点击查看</a
            >
          </div>
          <div class="box-conter">
            <div class="conter">
              <div>累计获得分红</div>
              <div>
                <strong>{{
                  (
                    Number(settle_hongbao.settlement_give_money || 0) +
                    Number(settle_hongbao.wait_settlement_give_money || 0)
                  ).toFixed(2)
                }}</strong>
                <span> 元</span>
              </div>
            </div>
            <div class="conter" style="border: none">
              <div>已结算分红</div>
              <div>
                <strong>{{
                  Number(settle_hongbao.settlement_give_money || 0).toFixed(2)
                }}</strong>
                <span> 元</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-title">
            <span style="font-size: 18px">共计已结算金额</span>
            <span
              style="font-size: 14px;color: red;display: inline-block;margin-left: 10px"
              >总金额 = 积分 - 红包 - 分红</span
            >
          </div>
          <div class="box-conter">
            <div class="conter" style="border: none">
              <div>
                <strong style="font-size: 20px">{{
                  Number(settle_hongbao.settlement_money || 0).toFixed(2)
                }}</strong>
                <span> 元</span>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      width="400px"
      center
      append-to-body
      destroy-on-close
      :before-close="beforeClose"
      title="结算付款码"
      :visible.sync="show_settle_code"
    >
      <div id="qrcode"></div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import UUID from "uuid";
import {
  settlement_bonus,
  settlement_pay,
  check_status
} from "@/api/integralMall";
import QRCode from "qrcodejs2";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      settle_hongbao: {},
      show_settle_code: false,
      timer: null,
      order: ""
    };
  },

  mounted() {
    this.get_hongbao_settle();
  },
  methods: {
    goto_settle() {
      let ntime = new Date().getTime();
      this.order = `${this.app_id}${ntime}${Math.floor(Math.random() * 10000)}`;
      // this.order = UUID.v4().split("-").join("");
      settlement_pay({ nonce: this.order, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          this.show_settle_code = true;
          this.$nextTick(() => {
            new QRCode("qrcode", {
              text: res.data,
              width: 345,
              height: 345
            });
          });
          this.timer = setInterval(() => {
            check_status({ app_id: this.app_id, nonce: this.order }).then(
              status => {
                if (status.code == 200) {
                  this.$message.success("支付成功");
                  clearInterval(this.timer);
                  this.timer = null;
                  this.get_hongbao_settle();
                  this.show_settle_code = false;
                }
              }
            );
          }, 2000);
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    beforeClose(done) {
      clearInterval(this.timer);
      this.timer = null;
      done();
    },
    async get_hongbao_settle() {
      const res = await settlement_bonus({ app_id: this.app_id });
      if (res.code == 200) {
        console.log(res);
        this.settle_hongbao = res.data;
      }
    },
    gotoDetail(key, id, settlement) {
      if (key == "settlement") {
        this.$router.push({
          path: "settlement_logs2",
          query: {
            key: key,
            id: id,
            settlement: settlement
          }
        });
      } else {
        this.$router.push({
          path: "settlement_logs",
          query: {
            key: key,
            id: id,
            settlement: settlement
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.new_vip {
  padding: 10px 50px 0 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
}

.box-conter {
  width: 100%;
  border-top: 1px solid #f5f5f5;
  display: flex;
  align-items: center;
  padding: 20px;
  .conter {
    //width: 10%;
    padding: 0 10px;
    text-align: center;
    border-right: 1px solid #ddd;
    font-size: 16px;
    div:nth-child(2) {
      margin-top: 5px;
      font-size: 20px;
      span {
        font-size: 16px;
      }
    }
  }
}
.date_picker_delete {
  width: 140px;
}
::v-deep .el-popover,
.el-radio-button:first-child:last-child .el-radio-button__inner {
  border-radius: 0;
}
::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0;
}
::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 0;
}
a {
  color: #00a4ff;
}
a:hover {
  cursor: pointer;
  border-bottom: 1px solid #00f;
}
</style>
